<template>
  <transition name="fade">
    <div class="fixed top-0 right-0 flex items-center justify-center bg-gray-500/50 h-screen w-screen z-10"
         v-if="show">
      <div class="relative bg-dark rounded-lg px-12 overflow-y-auto max-h-[90vh]"
           :class="type === 'small' ? 'w-[350px] py-6' : 'w-[650px] py-8'"
           @click.stop>
        <h1 class="text-xl text-center">{{ title }}</h1>
        <hr class="mt-4">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VModal",
  props: ['title', 'show', 'type']
}
</script>

<style scoped>

</style>